import { DefaultRecordType } from 'rc-table/lib/interface';
import { orderBy as lodashOredBy, get } from 'lodash';
import { parse } from 'date-fns';
import { GridFilter, FilterOperator, GridSort } from './interfaces';

type Union = number | string | boolean;

const filterFunctionMap: {
  [operators in FilterOperator]: (a: any, b: any) => boolean;
} = {
  // contains: (a: string, b: string) => (String(a).replace(/[\s()-]/g, '') || '').includes(b),
  contains: (a: string, b: string) => (String(a) || '').includes(b),
  notcontains: (a: string, b: string) => !(String(a) || '').includes(b),
  startWith: (a: string, b: string) => (String(a) || '').startsWith(b),
  eq: (a: Union, b: Union) => a === b,
  neq: (a: Union, b: Union) => a !== b,
  lt: (a: number, b: number) => a < b,
  lte: (a: number, b: number) => a <= b,
  gt: (a: number, b: number) => a > b,
  gte: (a: number, b: number) => a >= b,
};

function filterCallback(gridFilter: GridFilter) {
  const { filters } = gridFilter;

  return (gridRow: DefaultRecordType) => {
    if (!filters.length) return true;
    if (gridFilter.logic === 'and') {
      return filters.every((filter) => filterFunctionMap[filter.operator](get(gridRow, filter.field), filter.value));
    }
    return filters.some((filter) => filterFunctionMap[filter.operator](get(gridRow, filter.field), filter.value));
  };
}

export function filterBy(data: readonly DefaultRecordType[], gridFilter: GridFilter): DefaultRecordType[] {
  return data.filter(filterCallback(gridFilter));
}

export function orderBy(data: readonly DefaultRecordType[], gridSort: GridSort): DefaultRecordType[] {
  const fields = gridSort.map((sort) => {
    if (!sort.dateFormat) {
      return Array.isArray(sort.field) ? sort.field.join('.') : sort.field;
    }

    return function dateSort(element: DefaultRecordType) {
      return parse(get(element, sort.field), sort.dateFormat!, new Date());
    };
  });
  const directions = gridSort.map((sort) => sort.dir);
  return lodashOredBy(data, fields, directions);
}

export const getArrayByNumber = (number: number) => {
  const arr = [];
  for (let i = 0; i < number; i += 1) {
    arr.push(i);
  }

  return arr;
};
